import { authClient } from '@/lib/api/ts-rest';
import { useMutation } from '@tanstack/react-query';

export const useResetPassword = () => {
  const mutation = useMutation({
    mutationFn: (data: { token: string; newPassword: string }) =>
      authClient.resetPassword({ body: data }).then((res) => {
        if (res.status !== 201) throw new Error('Reset failed');
        return res.body;
      }),
  });

  return {
    resetPassword: mutation.mutate,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
};
